var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40002165_69833",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 31
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40002165_69833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.8125 21.4375H15.9375V19.5625H7.8125V21.4375ZM20.3125 21.4375H22.1875V9.5625H20.3125V21.4375ZM7.8125 16.4375H15.9375V14.5625H7.8125V16.4375ZM7.8125 11.4375H15.9375V9.5625H7.8125V11.4375ZM5.38469 26.125C4.75323 26.125 4.21875 25.9062 3.78125 25.4688C3.34375 25.0312 3.125 24.4968 3.125 23.8653V7.13469C3.125 6.50323 3.34375 5.96875 3.78125 5.53125C4.21875 5.09375 4.75323 4.875 5.38469 4.875H24.6153C25.2468 4.875 25.7812 5.09375 26.2188 5.53125C26.6562 5.96875 26.875 6.50323 26.875 7.13469V23.8653C26.875 24.4968 26.6562 25.0312 26.2188 25.4688C25.7812 25.9062 25.2468 26.125 24.6153 26.125H5.38469ZM5.38469 24.25H24.6153C24.7116 24.25 24.7997 24.2099 24.8797 24.1297C24.9599 24.0497 25 23.9616 25 23.8653V7.13469C25 7.03844 24.9599 6.95031 24.8797 6.87031C24.7997 6.7901 24.7116 6.75 24.6153 6.75H5.38469C5.28844 6.75 5.20031 6.7901 5.12031 6.87031C5.0401 6.95031 5 7.03844 5 7.13469V23.8653C5 23.9616 5.0401 24.0497 5.12031 24.1297C5.20031 24.2099 5.28844 24.25 5.38469 24.25Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessDoc);
export default __webpack_public_path__ + "static/media/BusinessDoc.51c98a174b638a7966e6b633fdc0ca03.svg";
export { ForwardRef as ReactComponent };